import { i18n } from "translations";

export enum EmployeeStatus {
  ACTIVE = 1,
  INACTIVE = 3,
  DELETE = 0,
}

export enum EmployeeGender {
  Male = "Male",
  Female = "Female",
  Other = "Other",
}

export enum EmployeeUserAppRole {
  Admin = "Admin",
  Employee = "Employee",
}

export enum EmployeeTaxObjectType {
  Resident = "Resident",
  NonResident = "NonResident",
}

export enum EmploymentStatus {
  Probationary = "Probationary",
  Termination = "Termination",
  Working = "Working",
  Maternity = "Maternity",
  LongTermLeave = "LongTermLeave",
  LongTermSickLeave = "LongTermSL",
  LongTermUnpaidLeave = "LongTermUL",
}

export enum EmployeeType {
  FullTime = "FTE",
  PartTime = "PTE",
  Internship = "ITE",
  Apprenticed = "APE",
  Temporary = "TEM",
  Contractors = "CON",
  TalentTraineeProgram = "TTP",
}

export enum EmployeeMaterialStatus {
  Single = "Single",
  Married = "Married",
  Divorced = "Divorced",
  Widowed = "Widowed",
  Other = "Other",
}

export const EmployeeStatusOptions = [
  {
    label: "Active",
    value: EmployeeStatus.ACTIVE,
  },
  {
    label: "Inactive",
    value: EmployeeStatus.INACTIVE,
  },
];

export const EmployeeGenderOptions = [
  {
    label: "Male",
    value: EmployeeGender.Male,
  },
  {
    label: "Female",
    value: EmployeeGender.Female,
  },
  {
    label: "Other",
    value: EmployeeGender.Other,
  },
];

export const EmployeeUserAppRoleOptions = [
  {
    label: "Employee",
    value: EmployeeUserAppRole.Employee,
  },
  {
    label: "Admin",
    value: EmployeeUserAppRole.Admin,
  },
];

export const EmployeeTaxObjectTypeOptions = [
  {
    label: i18n.t("objectTypeResident"),
    value: EmployeeTaxObjectType.Resident,
  },
  {
    label: i18n.t("objectTypeNonResident"),
    value: EmployeeTaxObjectType.NonResident,
  },
];

export const EmploymentStatusOptions = [
  {
    label: i18n.t("probationary"),
    value: EmploymentStatus.Probationary,
  },
  {
    label: i18n.t("termination"),
    value: EmploymentStatus.Termination,
  },
  {
    label: i18n.t("working"),
    value: EmploymentStatus.Working,
  },
  {
    label: i18n.t("maternity"),
    value: EmploymentStatus.Maternity,
  },
  {
    label: i18n.t("longTermLeave"),
    value: EmploymentStatus.LongTermLeave,
  },
  {
    label: i18n.t("longTermSickLeave"),
    value: EmploymentStatus.LongTermSickLeave,
  },
  {
    label: i18n.t("longTermUnpaidLeave"),
    value: EmploymentStatus.LongTermUnpaidLeave,
  },
];

export const EmployeeTypeOptions = [
  {
    label: i18n.t("employeeFullTime"),
    value: EmployeeType.FullTime,
  },
  {
    label: i18n.t("employeePartTime"),
    value: EmployeeType.PartTime,
  },
  {
    label: i18n.t("employeeInternship"),
    value: EmployeeType.Internship,
  },
  {
    label: i18n.t("employeeApprenticed"),
    value: EmployeeType.Apprenticed,
  },
  {
    label: i18n.t("employeeTemporary"),
    value: EmployeeType.Temporary,
  },
  {
    label: i18n.t("employeeContractors"),
    value: EmployeeType.Contractors,
  },
  {
    label: i18n.t("talentTraineeProgram"),
    value: EmployeeType.TalentTraineeProgram,
  },
];

export const EmployeeMaterialStatusOptions = [
  {
    label: i18n.t("single"),
    value: EmployeeMaterialStatus.Single,
  },
  {
    label: i18n.t("married"),
    value: EmployeeMaterialStatus.Married,
  },
  {
    label: i18n.t("divorced"),
    value: EmployeeMaterialStatus.Divorced,
  },
  {
    label: i18n.t("widowed"),
    value: EmployeeMaterialStatus.Widowed,
  },
  {
    label: i18n.t("other"),
    value: EmployeeMaterialStatus.Other,
  },
];
